import { Lang } from './types';

// Submission deadline, sourced from config (config/_defaults.yaml
// `submissionDeadlineJst`). The Amplify Hosting build injects it as
// REACT_APP_SUBMISSION_DEADLINE_JST via scripts/render_config.py (see the
// build phase in amplify.yml), so every DEPLOYED build is config-driven --
// there is no hard-coded cycle date in the bundle. The literal below is a
// last-resort guard for a local `npm start` / unit run that didn't export
// the var; keep it in sync with config to avoid surprising local output.
// See #166 / #157.
const deadlineIso =
    process.env.REACT_APP_SUBMISSION_DEADLINE_JST ?? '2026-09-07T23:59:59+09:00';
const deadline = new Date(deadlineIso);

export const renderDeadline = (lang: Lang) =>
    deadline.toLocaleString(lang, {
        // Always render the deadline in Japan Standard Time, regardless of
        // the viewer's browser timezone -- an overseas recommender must see
        // the same 23:59 JST cutoff, not their own local time. The explicit
        // JST marker (appended below) makes the timezone unambiguous.
        timeZone: 'Asia/Tokyo',
        month: 'short',
        day: 'numeric',
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
    }) + (lang === 'en' ? ' (JST)' : '（日本時間）');
